<gl-pro-modal (closeModal)="close(false)">
  <p>
    {{ 'prolong_message' | translate }}
    {{ endDatePro }}
    {{ 'prolong_message_second' | translate }}
  </p>
  @if (user.premiumRole === 'admin') {
    <div class="buttons">
      <button outline-button (click)="openPriceList()">{{ 'prolong_access' | translate }}</button>
    </div>
  }
</gl-pro-modal>
